import React from "react";
import { IconButton } from "@mui/material";
import IconFav from "src/assets/images/heart-favorite.png";
import { getInitialsImage } from "src/helpers/helperFunctions";
import RenderText from "src/Components/Text/RenderText";
import TestIcon from "src/assets/images/website-images/test-icon.png";
import BloodIcon from "src/assets/images/website-images/blood-icon.png";
import CartIcon from "src/assets/images/website-images/addcart-image-new.png";
import AddCartButton from "src/Components/GlobalComponents/AddCartButton";
import PriceView from "src/Components/GlobalComponents/PriceView";
import FavoriteCoponent from "src/Components/GlobalComponents/FavoriteCoponent";

interface IObj {
  _id: string;
  name: string;
  description: string;
  image: string;
  isLiked: boolean;
  regularPrice: number;
  salePrice: number | null;
  prescriptionRequired: boolean;
  testType: string;
  noOfBiomarkers: number;
}

interface TestWhishListCardProps {
  data: IObj;
  heart_id?: string;
  button_id?: string;
  handleRemove: () => void;
}

const BoxIcon = ({ icon, title }: { icon: string; title: string }) => {
  return (
    <div className="flex gap-1 items-center">
      <div className="w-[13px] h-[13px] 2xl:w-[15px] 2xl:h-[15px]  border border-gray-400 rounded-sm 2xl:rounded flex items-center justify-center">
        <img
          src={icon}
          alt="icon"
          className="max-w-[80%] max-h-[80%] object-contain"
        />
      </div>
      <RenderText className="font-Poppins-Regular font-size-12px text-[#333333]">
        {title}
      </RenderText>
    </div>
  );
};

const TestWhishListCard = ({
  data,
  heart_id,
  button_id,
  handleRemove,
}: TestWhishListCardProps) => {
  return (
    <div className="bg-white rounded-lg shadow-all-light-2 px-[6px] 2xl:px-2 py-2 2xl:py-3 flex gap-1 2xl:gap-2 items-center">
      {/* <IconButton onClick={handleRemove} id={`${heart_id}`}>
        <img src={IconFav} alt="Fav" className="w-[17px] 2xl:w-[20px]" />
      </IconButton> */}
      <FavoriteCoponent
        category="tests"
        onLikeProduct={handleRemove}
        id={data?._id}
        liked={data?.isLiked}
        className="bg-transparent"
        isWhishList
      />
      <div className="flex gap-2 2xl:gap-3 flex-1">
        <div className="max-w-[5vw] rounded-lg h-fit overflow-hidden">
          <img
            src={`${data.image || ""}`}
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.src = getInitialsImage(data.name, 112, 48, "#00443f");
            }}
            alt={data.name}
            className="aspect-square"
          />
        </div>
        <div className="w-[calc(100%-5vw-10px)] flex flex-col gap-1">
          <RenderText className="font-Montserrat-SemiBold font-size-20px wishlist-test-main-text-color">
            {data.name}
          </RenderText>
          <div className="flex gap-3">
            <BoxIcon icon={TestIcon} title={`${data.noOfBiomarkers} Tests`} />
            <BoxIcon icon={BloodIcon} title={`Blood Sample`} />
          </div>
          <div className="flex w-full gap-2 justify-between">
            <PriceView
              salePrice={data?.salePrice || null}
              regularPrice={data?.regularPrice || 0}
              className="!font-Poppins-SemiBold"
              regularClassName="!text-[#434343] font-size-15px-important"
              saleClassName="!text-[#202020] font-size-20px-important"
            />
            <AddCartButton
              id={button_id}
              productId={data?._id}
              type="diagnostic"
              itemType="product"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestWhishListCard;
